/* eslint-disable react/prop-types */
import PropTypes from 'prop-types'
import React from 'react'
import { FaCheck, FaChevronRight } from 'react-icons/fa'
import { longTextToSmall } from 'utils/helper'
import styled from 'styled-components'
import { LabelCount } from './DropdownMultiLevel'

// import RightArrow from '../assets/RightArrow';
interface IProps {
  item: any
  nextValue: any
  moveToNext: any
  activeItem: string | undefined
  selectedMenuItem: (value: any) => void
  labelCount?: LabelCount
}

const MenuItem = ({
  item,
  nextValue,
  moveToNext,
  activeItem,
  selectedMenuItem,
  labelCount = { Min: 0, Total: 0 },
}: IProps) => (
  <Div
    active={activeItem === item.id}
    className="menuItem"
    onClick={() => {
      selectedMenuItem(item)
      moveToNext(item)
    }}
  >
    <p className="value">{longTextToSmall(item.value, labelCount?.Min, labelCount?.Total)}</p>
    <p className="nextArrow" style={{ display: nextValue ? 'block' : 'none' }}>
      <FaChevronRight className="arrow-right" />
    </p>
    {activeItem === item.id && (
      <div className="check-icon" style={{ display: !nextValue ? 'block' : 'none' }}>
        <FaCheck className="check-icon" />
      </div>
    )}
  </Div>
)

const Div = styled.div<{ active: boolean | undefined }>`
  ${({ theme }) => theme.typography.s.normal}
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme, active }) => (active ? theme.colors.tertiary.lightest : 'transparent')};
  &:hover {
    background-color: ${({ theme }) => theme.colors.tertiary.lightest};
  }
  p {
    padding: 0.625rem 1rem;
    margin: 0;
  }
  .value {
    color: ${({ theme, active }) => (active ? theme.colors.tertiary.dark : theme.colors.neutral.neutral)};
  }
  .arrow-right {
    color: ${({ theme }) => theme.colors.grey.neutral};
  }
  .check-icon {
    color: ${({ theme }) => theme.colors.tertiary.neutral};
    margin-right: 0.75rem;
  }
`
MenuItem.propTypes = {
  item: PropTypes.shape({}).isRequired,
  nextValue: PropTypes.bool.isRequired,
  moveToNext: PropTypes.func.isRequired,
}

export default MenuItem
